// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrollArea {
  overflow: hidden;
  position: relative;
}
.scrollArea .scrollable {
  max-height: inherit;
  overflow: hidden;
  zoom: 1;
}
.scrollArea .scrollable.scrollX {
  overflow-x: scroll;
}
.scrollArea .scrollable.scrollY {
  overflow-y: scroll;
}
.scrollArea.fit {
  height: 100%;
  width: 100%;
}
.scrollArea.fit .scrollable {
  bottom: 0;
  left: 0;
  max-height: none;
  position: absolute;
  right: 0;
  top: 0;
}
.scrollArea .scrollNav {
  background-color: rgba(0,0,0,0.75);
  box-shadow: 0 0 10px 10px rgba(0,0,0,0.75);
  cursor: pointer;
  height: 24px;
  left: 10px;
  opacity: 0;
  position: absolute;
  right: 10px;
  transition: all 0.3s ease;
}
.scrollArea .scrollNav .scrollNavIcon {
  color: var(--active-color);
  display: block;
  width: 18px;
  height: 18px;
  margin: 0 auto;
  transition: color 0.3s ease;
}
.scrollArea .scrollNav:hover {
  background-color: rgba(0,0,0,0.9);
  box-shadow: 0 0 10px 10px rgba(0,0,0,0.9);
}
.scrollArea .scrollNav:hover .scrollNavIcon {
  color: var(--hover-color);
}
.scrollArea .scrollNavUp {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  top: 0;
  transform: translateY(-24px);
}
.scrollArea .scrollNavDown {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  bottom: 0;
  transform: translateY(24px);
}
.scrollArea.canScrollUp .scrollNavUp,
.scrollArea.canScrollDown .scrollNavDown {
  opacity: 1;
  transform: translateY(0);
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/containers/ScrollableArea.styl"],"names":[],"mappings":"AAAA;EACE,gBAAU;EACV,kBAAU;AACZ;AACE;EACE,mBAAY;EACZ,gBAAU;EACV,OAAM;AACV;AACI;EACE,kBAAY;AAClB;AACI;EACE,kBAAY;AAClB;AACE;EACE,YAAQ;EACR,WAAO;AACX;AACI;EACE,SAAQ;EACR,OAAM;EACN,gBAAY;EACZ,kBAAU;EACV,QAAO;EACP,MAAK;AACX;AACE;EACE,kCAAkB;EAClB,0CAAY;EACZ,eAAQ;EACR,YAAQ;EACR,UAAM;EACN,UAAS;EACT,kBAAU;EACV,WAAO;EACP,yBAAY;AAChB;AACI;EACE,0BAAO;EACP,cAAS;EACT,WAAO;EACP,YAAQ;EACR,cAAQ;EACR,2BAAY;AAClB;AACI;EACE,iCAAkB;EAClB,yCAAY;AAClB;AACM;EACE,yBAAO;AACf;AACE;EACE,+BAA2B;EAC3B,gCAA4B;EAC5B,MAAK;EACL,4BAAW;AACf;AACE;EACE,4BAAwB;EACxB,6BAAyB;EACzB,SAAQ;EACR,2BAAW;AACf;AACE;;EAEE,UAAS;EACT,wBAAW;AACf","sourcesContent":[".scrollArea\n  overflow: hidden\n  position: relative\n\n  .scrollable\n    max-height: inherit\n    overflow: hidden\n    zoom: 1\n\n    &.scrollX\n      overflow-x: scroll\n\n    &.scrollY\n      overflow-y: scroll\n\n  &.fit\n    height: 100%\n    width: 100%\n\n    .scrollable\n      bottom: 0\n      left: 0\n      max-height: none\n      position: absolute\n      right: 0\n      top: 0\n\n  .scrollNav\n    background-color: rgba(0, 0, 0, 0.75)\n    box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.75)\n    cursor: pointer\n    height: 24px\n    left: 10px\n    opacity: 0\n    position: absolute\n    right: 10px\n    transition: all 0.3s ease\n    \n    .scrollNavIcon\n      color: var(--active-color);\n      display: block;\n      width: 18px;\n      height: 18px;\n      margin: 0 auto;\n      transition: color 0.3s ease;\n\n    &:hover\n      background-color: rgba(0, 0, 0, 0.9)\n      box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.9)\n\n      .scrollNavIcon\n        color: var(--hover-color)\n\n  .scrollNavUp\n    border-bottom-left-radius: 12px\n    border-bottom-right-radius: 12px\n    top: 0\n    transform: translateY(-24px)\n\n  .scrollNavDown\n    border-top-left-radius: 12px\n    border-top-right-radius: 12px\n    bottom: 0\n    transform: translateY(24px)\n\n  &.canScrollUp .scrollNavUp,\n  &.canScrollDown .scrollNavDown\n    opacity: 1\n    transform: translateY(0)\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
